import axios from 'axios'
export const API_URL = 'https://api.goldpriceupdate.com';
// export const API_URL = 'http://localhost:6000';

export default function requestApi() {
   
   const request = axios.create({
      baseURL: API_URL,
      headers: {
         'Authorization':`Bearer ${localStorage.getItem('accessToken')?localStorage.getItem('accessToken'):null}`
      },
      responseType: 'json',
      socketPath: null,
      
   })
   request.interceptors.response.use(
      (response) => response,
      (error) => {
         console.log("error ==>", error);
         if (error.response) {
            console.log("error ==>",error.response.data);
            if (error.response.status === 401 || error.response.status === 403) {
               // localStorage.removeItem("accessToken");
               // localStorage.removeItem("user");
               // window.location.replace('/');
            }
            // console.log(error.response.headers);
         }
      }
   );
   return request;
}